/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `device_aux_battery_info` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class DeviceAuxBatteryInfoMesg : Mesg {
    public constructor() : super("DeviceAuxBatteryInfo", Profile.MesgNum.DEVICE_AUX_BATTERY_INFO)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** device_index. */
    public var deviceIndex: UByte?
        get() = getFieldValue(DEVICE_INDEX_FIELD_NUM) as? UByte
        set(value) = setFieldValue(DEVICE_INDEX_FIELD_NUM, value)

    /** battery_voltage, in V. */
    public var batteryVoltage: Double?
        get() = getFieldValue(BATTERY_VOLTAGE_FIELD_NUM) as? Double
        set(value) = setFieldValue(BATTERY_VOLTAGE_FIELD_NUM, value)

    /** battery_status. */
    public var batteryStatus: BatteryStatus?
        get() = (getFieldValue(BATTERY_STATUS_FIELD_NUM) as? UByte)?.let { BatteryStatus.fromValue(it) }
        set(value) = setFieldValue(BATTERY_STATUS_FIELD_NUM, value?.value)

    /** battery_identifier. */
    public var batteryIdentifier: UByte?
        get() = getFieldValue(BATTERY_IDENTIFIER_FIELD_NUM) as? UByte
        set(value) = setFieldValue(BATTERY_IDENTIFIER_FIELD_NUM, value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val DEVICE_INDEX_FIELD_NUM: UByte = 0u
        public const val BATTERY_VOLTAGE_FIELD_NUM: UByte = 1u
        public const val BATTERY_STATUS_FIELD_NUM: UByte = 2u
        public const val BATTERY_IDENTIFIER_FIELD_NUM: UByte = 3u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[0] = Field("DeviceIndex", 0u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[1] = Field("BatteryVoltage", 1u, BaseType.UINT16, 256.0, 0.0, "V", false)
            fields[2] = Field("BatteryStatus", 2u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[3] = Field("BatteryIdentifier", 3u, BaseType.UINT8, 1.0, 0.0, "", false)
            return fields
        }
    }
}
